import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import logo from '../../../../assets/images/jablotron-logo.png'
import useAppAuth from '../../../providers/AppAuthProvider/hooks/useAppAuth'
import { Avatar, Stack, Typography } from '@mui/material'

const Header = () => {
    const auth = useAppAuth()
    return (
        <Box
            component={'nav'}
            className='pt-6 md:pt-12 pb-2 bg-pantone-white-90 sticky top-0 z-10 mb-7 md:mb-0'
        >
            <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Box>
                    <Link href={process.env.REACT_APP_DASHBOARD_REDIRECT}>
                        <img
                            src={logo}
                            alt='logo'
                            className='h-[1.56rem] md:h-[2.125rem]'
                        />
                    </Link>
                </Box>
                <Stack
                    direction='row'
                    alignItems='center'
                    className='gap-2 md:gap-4'
                >
                    <Avatar
                        alt='user avatar'
                        className='w-8 h-8'
                    />
                    <Typography className='text-sm md:text-[1rem]'>
                        {auth.user?.name || auth.user?.email}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    )
}

export default Header
